// assets/component-tabs.js
// Shared tab switching for any tabbed UI (size guide, product features, etc).
// Uses event delegation — works with dynamically rendered content.
//
// Markup contract:
//   Container:   data-tabs
//   Tab button:  data-tab="0" (index)
//   Tab panel:   data-tab-content="0" (matching index)
//   Active tab gets .active class, active panel is shown.

(function () {
  'use strict';

  function switchTab(container, index) {
    // Deactivate all tabs
    container.querySelectorAll('[data-tab]').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.tab === index);
    });

    // Show matching panel, hide others
    container.querySelectorAll('[data-tab-content]').forEach((panel) => {
      panel.style.display = panel.dataset.tabContent === index ? '' : 'none';
    });

    container.dispatchEvent(
      new CustomEvent('tabs:change', {
        bubbles: true,
        detail: { index },
      })
    );
  }

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tab]');
    if (!tab) return;

    const container = tab.closest('[data-tabs]');
    if (!container) return;

    switchTab(container, tab.dataset.tab);
  });

  // Public API for programmatic tab switching
  window.wfhTabs = { switchTab };
})();
